import Button from 'Button';
import { TUTOR_BOT_BUTTON_HEIGHT_NUM_12_5, TUTOR_BOT_BUTTON_HEIGHT_NUM_18 } from 'TutorBotConversation';

type Props = {
    onPress?: () => void;
    controlState?: 'highlight' | 'default';
    disabled?: boolean;
    label: string;
    icon: React.ReactNode;
};

export function AudioControlBarButton({ onPress, controlState = 'default', disabled, label, icon }: Props) {
    return (
        <Button
            variant={controlState === 'highlight' ? 'solid-highlight' : 'solid'}
            isIconOnly
            aria-label={label}
            onPress={onPress}
            height={TUTOR_BOT_BUTTON_HEIGHT_NUM_18}
            tabletHeight={TUTOR_BOT_BUTTON_HEIGHT_NUM_12_5}
            round
            isDisabled={disabled}
        >
            {icon}
        </Button>
    );
}
